// extracted by mini-css-extract-plugin
export var active = "_ct-2";
export var recordingDot = "_ct-1";
export var recordingIndicator = "_ct-0";